import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SimpleCodeValue } from "../models/code-value.model";
import { GenericApiResponse } from "../models/api-response.model";
import { OtpResponse } from "../../auth/auth.service";

export interface UserRequest {
    userId: number | null;
    userName: string | null;
    encypretedPassword: string | null; // Note: "encypretedPassword" seems to be a typo; consider correcting it to "encryptedPassword"
    firstName: string | null;
    lastName: string | null;
    rank: string | null;
    phoneNumber: string | null;
    mobileNumber: string | null;
    ivrLanguage: string | null;
    emailAddress: string | null;
    allowSmsFlag: boolean | null;
    allowEmail: boolean | null;
    resPicUrl: string | null;
    status: string | null;
    areaName: string | null;
    qtrNo: string | null;
    blockNo: string | null;
    smsFlag: boolean;
    emailFlag: boolean;
    appZone: string | null;
    approvedAreaName: string | null;
    approvedQtrNo: string | null;
    approvedBlockNo: string | null;
    lookupType: string;
}

export interface LoginRequest {
    userName: string | null;
    password: string | null;
    instance: string | null;
}

export interface UserRegistrationVo {
    userRequest: UserRequest | null;
    loginRequest: LoginRequest | null;
    token: string | null;
    zoneId: number | null;
}


@Injectable({
    providedIn: 'root'
})
export class PublicService {

    constructor(private http: HttpClient) { }

    // GET request
    getEnabledZones(token: string): Observable<SimpleCodeValue[]> {
        return this.http.get<SimpleCodeValue[]>('/public/v1/enabled-zones/{token}'.replace('{token}', token));
    }

    getAreasByZoneId(zoneId: string, token: string): Observable<SimpleCodeValue[]> {
        return this.http.get<SimpleCodeValue[]>('/public/v1/get-areas/{zoneId}/{token}'.replace('{zoneId}', zoneId.toString()).replace('{token}', token));
    }

    checkUsernameAvailability(userName: string, token: string): Observable<GenericApiResponse> {
        return this.http.get<GenericApiResponse>('/public/v1/find-username/{userName}/{token}'.replace('{userName}', userName.toString()).replace('{token}', token));
    }

    requestOtpForSignUp(mobileNumber: string, captchaResponse: string, otpType: string | null, selectedStation: string, email: string): Observable<OtpResponse> {
        const url = `/public/v1/register/validate-user/${encodeURIComponent(mobileNumber)}/${encodeURIComponent(captchaResponse)}/${encodeURIComponent(selectedStation)}`;
        var params = otpType ? new HttpParams().set('otp', otpType) : new HttpParams();
        if (email) {
            params = params.set('email', email);
        }
        return this.http.get<OtpResponse>(url, { params });
    }

    registerUserRequest(body: UserRegistrationVo): Observable<GenericApiResponse> {
        return this.http.post<GenericApiResponse>('/public/v1/register-user', body);
    }

}
